// import consts from "@/consts"
// import {arraySplitIntoChunks} from "@/lib/lib";
export default {
    state: {},
    actions: {
        fetchAccessRights({getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args?.objectName) {
                    return reject(false)
                }

                this.$api.accessrights.getAccessRights(args?.userId, args.objectName, args?.objectId, args?.params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
            })
        },
        saveAccessRights({commit}, args) {
            return new Promise((resolve, reject) => {
                let userId = args.userId
                let objectName = args.objectName
                let objectId = args.objectId
                let data = args.data
                //let params = args.params
                //const params = {expand: consts.api.units.expand.join()}//, ...with_removed }//, fields: unitsFields.join()}
                this.$api.accessrights.updateAccessRights(userId, objectName, objectId,  data/*, params*/)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('');
                            resolve(response)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
    },
    mutations: {},
    getters: {}
}
